"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicV2Ai = void 0;
const AbilityArgs_1 = require("../../core/abilities/AbilityArgs");
const core_1 = require("../../core/actions/core");
const EffectType_1 = require("../../core/effects/EffectType");
const enums_1 = require("../../core/enums");
const core_2 = require("../../core/event-handlers/core");
const EventFilter_1 = require("../../core/events/EventFilter");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Copy_1 = require("../../utils/Copy");
const Enum_1 = require("../../utils/Enum");
const Random_1 = require("../../utils/Random");
let BasicV2Ai = class BasicV2Ai {
    init(sequence, container, state) {
        container.registerAiEventHandler(state.selfId, EventType_1.EventType.Damaged, Schedule_1.Schedule.Unlimited, state.selfId);
        container.registerAiEventHandler(state.selfId, EventType_1.EventType.Tick, Schedule_1.Schedule.Unlimited, state.selfId);
        const { eventHandlers = [], reactions = [] } = state.args;
        eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.forEach(({ event, schedule = Schedule_1.Schedule.Unlimited, target = Target_1.Target.Self, filter, ...more }) => {
            container.selectLivingTargets(state.selfId, target)
                .forEach(targetId => {
                // the schedule must be deep copied, that way its state isn't shared.
                schedule = (0, Copy_1.deepCopy)(schedule);
                const handlerArgs = more["basicHandlerArgs"];
                if (handlerArgs) {
                    container.registerEventHandler(targetId, event, schedule, handlerArgs, filter);
                    return;
                }
                const handler = more["handler"];
                if (handler) {
                    const useSequence = handler.key === "DispatchActions_OnHealthThreshold" ? sequence
                        : undefined;
                    container.registerEventHandlerScript(targetId, event, schedule, handler.key, handler.args, filter, useSequence);
                    return;
                }
            });
        });
        state.meta.reactionStates = [];
        const alreadyRegistered = new Set();
        reactions.forEach(reaction => {
            var _a;
            container.selectLivingTargets(state.selfId, (_a = reaction.triggerFrom) !== null && _a !== void 0 ? _a : Target_1.Target.Self)
                .forEach(targetId => {
                var _a;
                const registrationKey = `${reaction.triggerEvent}.${targetId}`;
                if (!alreadyRegistered.has(registrationKey)) {
                    container.registerEventHandler(targetId, (0, Enum_1.enumValue)(EventType_1.EventType, reaction.triggerEvent), Schedule_1.Schedule.Unlimited, new core_2.TriggerAiEventHandlerArgs(state.selfId));
                    alreadyRegistered.add(registrationKey);
                }
                state.meta.reactionStates.push({
                    schedule: (0, Copy_1.deepCopy)((_a = reaction.triggerSchedule) !== null && _a !== void 0 ? _a : Schedule_1.Schedule.Unlimited)
                });
            });
        });
    }
    handleEvent(sequence, container, state, e) {
        var _a, _b;
        const nextReaction = ((_a = state.args.reactions) !== null && _a !== void 0 ? _a : [])
            .map((reaction, position) => ({
            reaction,
            position
        }))
            .sort((a, b) => b.reaction.priority - a.reaction.priority)
            .filter(({ reaction }) => reaction.triggerEvent === e.args.__typeName)
            .filter(({ reaction }) => EventFilter_1.EventFilter.Test(reaction.triggerEventFilter, e.args))
            .find(({ position }) => {
            Schedule_1.Schedule.update(state.meta.reactionStates[position].schedule);
            return Schedule_1.Schedule.ready(state.meta.reactionStates[position].schedule);
        });
        if (nextReaction) {
            Schedule_1.Schedule.emit(state.meta.reactionStates[nextReaction.position].schedule);
            container.selectLivingTargets(state.selfId, (_b = nextReaction.reaction.triggerFrom) !== null && _b !== void 0 ? _b : Target_1.Target.Self)
                .forEach(triggerFromId => {
                container.dispatch(sequence, triggerFromId, nextReaction.reaction.action);
            });
        }
        switch (e.args.__type) {
            case EventType_1.EventType.Tick: {
                state.meta.tickTargetId = (0, Random_1.randomElement)(container.selectLivingTargets(state.selfId, Target_1.Target.AllEnemies));
                state.meta.friendlyTickTargetId = (0, Random_1.randomElement)(container.selectLivingTargets(state.selfId, Target_1.Target.AllAllies));
                return;
            }
            case EventType_1.EventType.Damaged: {
                const { damagedBy } = e.args;
                state.meta.lastDamagedById = damagedBy;
                return;
            }
        }
    }
    selectLivingTarget(container, state, args) {
        var _a;
        let targetId = Number.MAX_SAFE_INTEGER;
        const livingTargets = container.selectLivingTargets(state.selfId, Target_1.Target.AllEnemies);
        // TODO: remove enemyTargetSelectorType
        switch ((_a = args.target) !== null && _a !== void 0 ? _a : args.enemyTargetSelectorType) {
            case "self": {
                targetId = state.selfId;
                break;
            }
            case "lastDamagedBy": {
                targetId = state.meta.lastDamagedById;
                break;
            }
            case "lowestHealth": {
                [targetId] = livingTargets.sort((a, b) => container.getAttributeScore(a, enums_1.AttributeType.Health) - container.getAttributeScore(b, enums_1.AttributeType.Health));
                break;
            }
            case "highestHealth": {
                [targetId] = livingTargets.sort((a, b) => container.getAttributeScore(b, enums_1.AttributeType.Health) - container.getAttributeScore(a, enums_1.AttributeType.Health));
                break;
            }
            case "random": {
                targetId = (0, Random_1.randomElement)(livingTargets);
                break;
            }
            case "randomTick": {
                targetId = state.meta.tickTargetId;
                break;
            }
        }
        if (container.isDeceased(targetId)) {
            targetId = (0, Random_1.randomElement)(livingTargets);
        }
        return targetId;
    }
    selectLivingFriendlyTarget(container, state, args) {
        var _a;
        let targetId = Number.MAX_SAFE_INTEGER;
        const livingTargets = container.selectLivingTargets(state.selfId, Target_1.Target.AllAllies);
        // TODO: remove enemyTargetSelectorType
        switch ((_a = args.target) !== null && _a !== void 0 ? _a : args.enemyTargetSelectorType) {
            case "self": {
                targetId = state.selfId;
                break;
            }
            case "lastDamagedBy": {
                targetId = state.meta.lastDamagedById;
                break;
            }
            case "lowestHealth": {
                [targetId] = livingTargets.sort((a, b) => container.getAttributeScore(a, enums_1.AttributeType.Health) - container.getAttributeScore(b, enums_1.AttributeType.Health));
                break;
            }
            case "highestHealth": {
                [targetId] = livingTargets.sort((a, b) => container.getAttributeScore(b, enums_1.AttributeType.Health) - container.getAttributeScore(a, enums_1.AttributeType.Health));
                break;
            }
            case "random": {
                targetId = (0, Random_1.randomElement)(livingTargets);
                break;
            }
            case "randomTick": {
                targetId = state.meta.friendlyTickTargetId;
                break;
            }
        }
        if (container.isDeceased(targetId)) {
            targetId = (0, Random_1.randomElement)(livingTargets);
        }
        return targetId;
    }
    action(sequence, container, state) {
        const livingEnemies = container.selectLivingTargets(state.selfId, Target_1.Target.AllEnemies);
        for (let i = 0; i < state.args.abilityPriorities.length; i++) {
            const abilityArgs = state.args.abilityPriorities.at(i);
            const ability = container.getAbilityInSlot(state.selfId, abilityArgs.slot);
            if (ability.maxUses > 0 && ability.invokeCounter >= ability.maxUses) {
                continue;
            }
            const targetId = this.selectLivingTarget(container, state, abilityArgs);
            if (ability && !ability.disabled) {
                let target = Target_1.Target.None;
                switch (ability.targetType) {
                    case "Self":
                        target = Target_1.Target.Self;
                        break;
                    case "OneEnemies":
                        if (container.isDeceased(targetId)) {
                            return;
                        }
                        target = Target_1.Target.OneEnemy(targetId);
                        break;
                    case "AllEnemies":
                        if (livingEnemies.length === 0) {
                            return;
                        }
                        target = Target_1.Target.AllEnemies;
                        break;
                    case "OneAllies":
                        const livingAllies = container.selectLivingTargets(state.selfId, Target_1.Target.AllAllies);
                        if (livingAllies.length === 0) {
                            return;
                        }
                        target = Target_1.Target.OneAlly(this.selectLivingFriendlyTarget(container, state, abilityArgs));
                        break;
                    case "AllAllies":
                        target = Target_1.Target.AllAllies;
                        break;
                    case "None":
                        // noop
                        return;
                }
                const args = AbilityArgs_1.AbilityArgs.FromTypeName(ability.abilityType, target);
                return container.useAbility(sequence, state.selfId, args, true);
            }
        }
        const fallbackTargetId = (0, Random_1.randomElement)(livingEnemies);
        if (container.isDeceased(fallbackTargetId)) {
            return;
        }
        return container.useAbility(sequence, state.selfId, AbilityArgs_1.AbilityArgs.FromTypeName("Chop", Target_1.Target.OneEnemy(fallbackTargetId)), false);
    }
    nextTurn(sequence, container, state) {
        const { minActionsPerTurn = 1, maxActionsPerTurn = 1 } = state.args;
        const actionsThisTurn = minActionsPerTurn === maxActionsPerTurn ? minActionsPerTurn
            : (0, Random_1.random)(minActionsPerTurn, maxActionsPerTurn);
        if (actionsThisTurn === 0) {
            container.dispatch(sequence, state.selfId, new core_1.DoNothingActionArgs());
        }
        for (let i = 0; i < actionsThisTurn; i++) {
            if (container.isDeceased(state.selfId)) {
                return;
            }
            else if (container.hasEffectOfType(state.selfId, EffectType_1.EffectType.Stun)) {
                return;
            }
            this.action(sequence, container, state);
        }
    }
};
BasicV2Ai = __decorate([
    Registries_1.Ai.register("BasicV2")
], BasicV2Ai);
exports.BasicV2Ai = BasicV2Ai;
